import { render, staticRenderFns } from "./chateau-ausone.vue?vue&type=template&id=a26202c8&scoped=true"
import script from "./chateau-ausone.vue?vue&type=script&lang=js"
export * from "./chateau-ausone.vue?vue&type=script&lang=js"
import style0 from "./chateau-ausone.vue?vue&type=style&index=0&id=a26202c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26202c8",
  null
  
)

export default component.exports